export default {"src":"https://images-cdn-staging.curipod.com/pr-a8ec12af/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};